import React from 'react';
import { useSelector } from 'react-redux';

import { UploadOutlined } from '@ant-design/icons';

import { RibbonButton } from 'common/components';
import gridViewSelectors from 'common/components/grid-view/controllers/selectors';
import UploadTemplateAPLModal from './components/UploadTemplateAPLModal';

import { useGlobalModal } from 'hooks';
import { useCheckOwnerCompanyId, useCheckProductAdministrator } from './hooks';

import { MASTER_APL_NAME } from './constants';

const UpdateMasterAPLRibbon = () => {
  const { openModal, MODAL_NAMES, checkModalVisible, closeAllModal } =
    useGlobalModal();

  const selectedProducts = useSelector(
    gridViewSelectors.makeSelectDetailCurrentITemsSelection()
  );

  const isMasterAPLSelected =
    selectedProducts?.[0]?.aplName === MASTER_APL_NAME;

  const isProductAdministrator = useCheckProductAdministrator();
  const isOwnerMember = useCheckOwnerCompanyId(
    selectedProducts?.[0]?.ownerCompanyId
  );

  const disableUpdateMasterApl = () => {
    if (selectedProducts?.length !== 1) return true;
    if (!isMasterAPLSelected || !isProductAdministrator || !isOwnerMember)
      return true;
    return false;
  };

  const isDisabled = disableUpdateMasterApl();

  const visibleModal = checkModalVisible(MODAL_NAMES.UPDATE_MASTER_APL);

  return (
    <>
      <RibbonButton
        size='small'
        icon={<UploadOutlined style={{ height: 26 }} />}
        label={'Update Master APL'}
        onClick={() => openModal(MODAL_NAMES.UPDATE_MASTER_APL)}
        disabled={isDisabled}
      />

      <UploadTemplateAPLModal
        visibleModal={visibleModal}
        aplId={selectedProducts?.[0]?.id}
        turnOffModal={() => closeAllModal()}
        aplDetail={selectedProducts?.[0]}
      />
    </>
  );
};

export default UpdateMasterAPLRibbon;
